
import React, { useMemo, useState } from "react";
import BookmarksPicker from "@/Components/BookmarksPicker";
import { useSelector } from "react-redux";
import LoginSignup from "@/Components/LoginSignup";
import Icon from "@/Components/Icon";

export default function   BookmarkEvent({
  pubkey = "",
  d = "",
  kind = 30023,
  image = "",
  itemType = "a",
  extraData = "",
  label = false,
}) {
  const userKeys = useSelector((state) => state.userKeys);
  const userBookmarks = useSelector((state) => state.userBookmarks);
  const [showBookmarksPicker, setShowBookmarksPicker] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const itemTypes = {
    a: `${kind}:${pubkey}:${d}`,
    e: pubkey,
    r: pubkey,
    t: pubkey,
  };

  const isBookmarked = useMemo(() => {
    return userKeys
      ? userBookmarks.find((bookmark) =>
          bookmark.items.find((item) => item === itemTypes[itemType])
        )
      : false;
  }, [userBookmarks, userKeys]);

  return (
    <>
      {showBookmarksPicker && (
        <BookmarksPicker
          pubkey={pubkey}
          d={d}
          kind={kind}
          exit={() => setShowBookmarksPicker(false)}
          image={image}
          itemType={itemType}
          extraData={extraData}
        />
      )}
      {isLogin && <LoginSignup exit={() => setIsLogin(false)} />}
      <div
        className="fx-centered fx-start-h fit-container pointer"
        onClick={(e) => {
          e.stopPropagation();
          !userKeys ? setIsLogin(true) : setShowBookmarksPicker(true);
        }}
      >
        <Icon
          name={isBookmarked ? "bookmark-i-b" : "bookmark-i"}
          size={24}
        />
          {label && <p>{label}</p>}
      </div>
    </>
  );
}
